import React from 'react';
import styled from 'styled-components';

import TextareaField from '~fields/TextareaField';
import SelectField from '~fields/SelectField';
import CheckboxField from '~fields/CheckboxField';
import SpaceSelectField from '~fields/SpaceSelectField';
import PhoneField from '~fields/PhoneField';

const isInfectionRisk = choices => {
  const values = choices.map(choice => choice.value);

  const riskValues = ['ERISTYSJATE', 'ERISTYSPYYKKI', 'SOLUNSALPAAJAJATE'];

  return values.some(value => riskValues.includes(value));
};

const TrashCansForm = props => {
  const { formik, organizations, formId } = props;

  return (
    <>
      <FieldWrapper>
        <SelectField
          fallbackLabel="Valitse jätetyyppi"
          isMulti
          name="wasteType"
          placeholder="Valitse"
          onChange={value =>
            formik.setFieldValue('infectionRisk', isInfectionRisk(value))
          }
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <CheckboxField
          fallbackLabel="Tilaan vain uuden astian"
          name="newContainer"
        />
      </FieldWrapper>

      <FieldWrapper>
        <SpaceSelectField
          required
          name="pickupSpace"
          organizations={organizations}
          formId={formId}
          disableCollapse
        />
      </FieldWrapper>

      <FieldWrapper>
        <TextareaField
          placeholder="Tarkennus kuljetukseen tai laskutukseen"
          name="additionalInfo"
          fallbackLabel="Lisätietoa"
          rows={5}
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <PhoneField
          required
          fallbackLabel="Puhelinnumero"
          name="contactPhone"
        />
      </FieldWrapper>

      <FieldWrapper>
        <CheckboxField fallbackLabel="Tartuntavaara" name="infectionRisk" />
      </FieldWrapper>

      {/* <FieldWrapper>
        <Payer />
      </FieldWrapper> */}
    </>
  );
};

const FieldWrapper = props => <FieldContainer>{props.children}</FieldContainer>;

const FieldContainer = styled.div`
  margin-bottom: 24px;
`;

export default TrashCansForm;
